import React from 'react';
import PropTypes from 'prop-types';

const DownloadIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 12">
        <g>
            <g fill={fill}>
                <path d="M6.562 9.77a.658.658 0 00.892 0l1.653-1.572c.674-.646-.337-1.616-1.011-.97l-.007.006c-.208.2-.377.135-.377-.149V5.828a.7.7 0 00-.719-.685h.008a.7.7 0 00-.719.685v1.257c0 .285-.169.351-.377.149l-.007-.006c-.674-.646-1.685.323-1.011.97z" fillRule="evenodd" />
                <path d="M13.276 3.086H.718v1.371h12.558z" />
                <path d="M3.712 0a1.867 1.867 0 011.1.393l.574.478a.572.572 0 00.156.055h7.382A1.053 1.053 0 0114 1.954l-.007 9.018A1.053 1.053 0 0112.917 12H1.077A1.053 1.053 0 010 10.973V1.027A1.054 1.054 0 011.076 0zM1.435 10.628h11.124l.006-8.331H5.542a1.866 1.866 0 01-1.1-.393l-.574-.478a.575.575 0 00-.157-.055H1.435z" />
            </g>
        </g>
    </svg>
);

DownloadIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

DownloadIcon.defaultProps = {
    width: '14',
    height: '12',
    fill: '#4b254e'
};

export default DownloadIcon;
